import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GetExercisePerformanceRecordsResponse } from '@me-fit-mono/typings';
import { WorkoutStepData } from 'src/app/state/workout.state.service';

export interface PersonalRecordsSelection {
  [exerciseId: string]: Pick<WorkoutStepData, 'value'|'weightValue'|'sets'>;
}

export interface PersonalRecordsSelectionModalParams {
  exerciseMap: GetExercisePerformanceRecordsResponse['exerciseMap'];
  exercises: GetExercisePerformanceRecordsResponse['exercises'];
}

@Component({
  selector: 'me-personal-records-selection-modal',
  templateUrl: './personal-records-selection-modal.component.html'
})
export class PersonalRecordsSelectionModalComponent {
  @Input() customerId: string;
  @Input() exerciseMap: PersonalRecordsSelectionModalParams['exerciseMap'];
  @Input() exercises: PersonalRecordsSelectionModalParams['exercises'];

  // Holds the user's selection for each exercise
  selectedRecords: PersonalRecordsSelection = {};

  compareWith = (a: GetExercisePerformanceRecordsResponse['exerciseMap'][string][number], b: GetExercisePerformanceRecordsResponse['exerciseMap'][string][number]) => {
    return a.value === b.value && a.weightValue === b.weightValue && a.sets === b.sets;
  };

  constructor(
    private modalCtrl: ModalController,
  ) {}

  selectRecord(exerciseId: string, record: GetExercisePerformanceRecordsResponse['exerciseMap'][string][number]) {
    this.selectedRecords[exerciseId] = {
      value: record.value,
      weightValue: record.weightValue,
      sets: record.sets,
    };
  }

  dismiss() {
    this.modalCtrl.dismiss(this.selectedRecords);
  }
}
